import { erpApi } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";

const { post } = erpApi();

/**
 * Hook mutation para obtener reporte de contratos pendientes
 */
export const useObtenerReporteContratosPendientes = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        // `${urlBackendSoftnet}api/get-contratospendientessoftneteva/`,
        'https://api.tvmax.ec/api/get-contratospendientessoftneteva',
        params,
        true
      );
      return resp;
    },
  });
};
